module.exports = __webpack_public_path__ + "static/orlando-44ef4dde0a8b4ae11c634e46f85ffe24.jpg";